import React from 'react';
import PropTypes from 'prop-types';
// import { KeyHighlights } from '../../../molecules/key-highlights';
import PopularWidgetPiano from '../../../atoms/popular-widget-piano';
// import MostRead from '../../../molecules/most-read';

const SideNotes = ({ cards, mostRead, story = {} }) => {
  // if (story['story-template'] === 'live-blog') return <KeyHighlights cards={cards} />;
  return <PopularWidgetPiano />;
  // return <MostRead mostRead={mostRead} story={story} />;
};

SideNotes.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.any).isRequired,
  mostRead: PropTypes.object,
  story: PropTypes.object
};

export default SideNotes;
